type TranslateFn = (key: string) => string;

/** Sumsub 拒绝原因错误码 -> 用户端 i18n key */
const KYC_FAIL_REASON_CODE_MAP: Record<string, string> = {
  // 人脸活体
  BAD_FACE_MATCHING: "KYC_SUMSUB_REJECT_TIP_FRONT_14",
  FRAUDULENT_LIVENESS: "KYC_SUMSUB_REJECT_TIP_FRONT_15",
  BAD_SELFIE: "KYC_SUMSUB_REJECT_TIP_FRONT_15",
  BAD_VIDEO_SELFIE: "KYC_SUMSUB_REJECT_TIP_FRONT_16",
  UNSUITABLE_ENV: "KYC_SUMSUB_REJECT_TIP_FRONT_17",
  SANCTIONS: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  THIRD_PARTY_INVOLVED: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  UNSUPPORTED_LANGUAGE: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  APPLICANT_INTERRUPTED_INTERVIEW: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  COMPANY_NOT_DEFINED_BENEFICIARIES: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  COMPANY_NOT_DEFINED_REPRESENTATIVES: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  COMPANY_NOT_DEFINED_STRUCTURE: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  COMPANY_NOT_VALIDATED_BENEFICIARIES: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  COMPANY_NOT_VALIDATED_REPRESENTATIVES: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  CONNECTION_INTERRUPTED: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  DOCUMENT_MISSING: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  INCOMPATIBLE_LANGUAGE: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  // 客观不能通过
  ADVERSE_MEDIA: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  CRIMINAL: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  PEP: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  BLACKLIST: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  BLOCKLIST: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  REGULATIONS_VIOLATIONS: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  WRONG_USER_REGION: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  CHECK_UNAVAILABLE: "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  // 证件信息
  AGE_REQUIREMENT_MISMATCH: "KYC_SUMSUB_REJECT_TIP_FRONT_2",
  COMPROMISED_PERSONS: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  BAD_PROOF_OF_ADDRESS: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  BAD_PROOF_OF_IDENTITY: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  BAD_PROOF_OF_PAYMENT: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  INCORRECT_SOCIAL_NUMBER: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  PROBLEMATIC_APPLICANT_DATA: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  WRONG_ADDRESS: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  SELFIE_MISMATCH: "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  DUPLICATE: "KYC_SUMSUB_REJECT_TIP_FRONT_4",
  NOT_DOCUMENT: "KYC_SUMSUB_REJECT_TIP_FRONT_6",
  // 证件本身
  SCREENSHOTS: "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  FORGERY: "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  FRAUDULENT_PATTERNS: "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  GRAPHIC_EDITOR: "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  BLACK_AND_WHITE: "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  UNSATISFACTORY_PHOTOS: "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  INCOMPLETE_DOCUMENT: "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  DOCUMENT_DAMAGED: "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  DOCUMENT_PAGE_MISSING: "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  EXPIRATION_DATE: "KYC_SUMSUB_REJECT_TIP_FRONT_11",
  ID_INVALID: "KYC_SUMSUB_REJECT_TIP_FRONT_11",
  INCONSISTENT_PROFILE: "KYC_SUMSUB_REJECT_TIP_FRONT_12",
  SPAM: "KYC_SUMSUB_REJECT_TIP_FRONT_13",
};

/** 后端中文描述 -> 用户端 i18n key */
const KYC_FAIL_REASON_CN_MAP: Record<string, string> = {
  // 人脸活体
  "文档和自拍照之间的面部检查失败。": "KYC_SUMSUB_REJECT_TIP_FRONT_14",
  "试图绕过活性检查。": "KYC_SUMSUB_REJECT_TIP_FRONT_15",
  "申请人上传了一张糟糕的自拍照。": "KYC_SUMSUB_REJECT_TIP_FRONT_15",
  "申请人上传了一张糟糕的自拍照视频。": "KYC_SUMSUB_REJECT_TIP_FRONT_16",
  "在视频识别通话中，申请人要么不是独自一人，要么是看不见的。": "KYC_SUMSUB_REJECT_TIP_FRONT_17",
  "该申请人被发现在制裁名单上。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "申请人正在向第三方收费进行验证。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "视频识别语言不受支持。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "在视频识别电话中，申请人拒绝结束面试。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "无法识别并适当核实该实体的受益所有人。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "代表未定义。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "无法建立实体控制结构。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "受益人未经验证。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "代表未经过验证。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "视频识别呼叫连接已中断。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "在视频识别电话中，申请人拒绝出示或没有所需文件。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "申请人应上传其文件的译文。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  // 客观不能通过
  "申请人在不利的媒体中被发现。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "申请人有违法行为。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "申请人属于 PEP 类别。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "申请人已被我们列入黑名单。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "申请人已被您列入黑名单。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "违反规定。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "当某些地区/国家的申请人不允许注册时。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  "数据库不可用。": "KYC_SUMSUB_REJECT_TIP_FRONT_1",
  // 证件信息
  "不符合年龄要求（例如不能向 25 岁以下的人租车）。": "KYC_SUMSUB_REJECT_TIP_FRONT_2",
  "申请人不符合妥协人政治。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "申请人上传了错误的地址证明。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "申请人上传了错误的身份证件。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "申请人上传了错误的付款证明。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "申请人提供的社会号码（例如 SSN）不正确。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "申请人数据与文件中的数据不符。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "文档中的地址与用户输入的地址不匹配。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "申请人照片（个人资料图片）与所提供文件上的照片不符。": "KYC_SUMSUB_REJECT_TIP_FRONT_3",
  "该申请人已为此客户创建，法规不允许重复。": "KYC_SUMSUB_REJECT_TIP_FRONT_4",
  "提供的文件与验证程序无关。": "KYC_SUMSUB_REJECT_TIP_FRONT_6",
  // 证件本身
  "申请人上传了截图。": "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  "已进行伪造尝试。": "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  "检测到欺诈行为。": "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  "文档或其数据的亮度、对比度、内容等已更改。": "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  "申请人上传了证件的黑白照片。": "KYC_SUMSUB_REJECT_TIP_FRONT_8",
  "照片存在问题，例如质量差或信息被掩盖。": "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  "文档中缺少某些信息，或者部分信息可见。": "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  "文档已损坏。": "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  "文档的某些页面丢失。": "KYC_SUMSUB_REJECT_TIP_FRONT_9",
  "用户上传了过期的文档。": "KYC_SUMSUB_REJECT_TIP_FRONT_11",
  "识别个人身份的文件（如护照或身份证）无效。": "KYC_SUMSUB_REJECT_TIP_FRONT_11",
  "不同人的数据或文件被上传给一名申请人。": "KYC_SUMSUB_REJECT_TIP_FRONT_12",
  "申请人被错误创建或只是垃圾邮件用户（提供了不相关的图像）。": "KYC_SUMSUB_REJECT_TIP_FRONT_13",
};

export function getKycFailReasonI18nKey(failReason?: string): string | undefined {
  if (!failReason) return undefined;
  const trimmed = failReason.trim();
  if (trimmed.startsWith("KYC_SUMSUB_REJECT_TIP_")) return trimmed;
  return KYC_FAIL_REASON_CODE_MAP[trimmed] || KYC_FAIL_REASON_CN_MAP[trimmed];
}

export function getKycFailReasonText(failReason: string | undefined, t: TranslateFn): string {
  if (!failReason) return "";
  const i18nKey = getKycFailReasonI18nKey(failReason);
  if (i18nKey) {
    const translated = t(i18nKey);
    return translated !== i18nKey ? translated : failReason;
  }
  return failReason;
}
